import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import InfoTooltip from "Shared/InfoTooltip";
import { withTheme } from "styled-components";
import { WithTheme } from "src/styles/createStyledComponentsTheme";
import { ApplicationStore } from "src/store";
import { patchConditionalRebatesHandRaisersRequest } from "src/store/actions/conditionalRebates";
import { getVehicleMake } from "src/store/selectors/vehicles";

interface Props {
    vin: string;
}

export const HandRaisers = ({
    theme: {
        palette: {
            primary: { main: primaryColor },
        },
    },
    vehicleMake,
    handRaisers,
    dealership,
    dealUuid,
    patchConditionalRebatesHandRaisers,
}: Props & WithTheme & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    return (
        <div className={"conditional_rebates"}>
            {Object.keys(handRaisers)?.map((rebate) => (
                <div className={"conditional_rebate_row"} key={rebate}>
                    {handRaisers[rebate] ? (
                        <div
                            className="conditional_rebate conditional_rebate_selected"
                            style={{ borderColor: primaryColor, backgroundColor: "#fff" }}
                            onClick={() => patchConditionalRebatesHandRaisers(rebate, false, dealUuid)}
                        >
                            {t(`ConditionalRebates.${rebate}`, { make: vehicleMake })}
                        </div>
                    ) : (
                        <div
                            className="conditional_rebate conditional_rebate_unselected"
                            onClick={() => patchConditionalRebatesHandRaisers(rebate, true, dealUuid)}
                        >
                            {t(`ConditionalRebates.${rebate}`, { make: vehicleMake })}
                        </div>
                    )}
                    <InfoTooltip
                        className={"conditional_rebate_tooltip"}
                        text={t("ConditionalRebates.ToolTip", { dealership })}
                    />
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => ({
    vehicleMake: getVehicleMake(state, vin),
    handRaisers: state.conditionalRebates.handRaisers,
    dealership: state.account.name,
    dealUuid: state.deal.uuid as string,
});

const mapDispatchToProps = {
    patchConditionalRebatesHandRaisers: patchConditionalRebatesHandRaisersRequest,
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(HandRaisers));
